<template>
  <div class="no-data">
    <img src="../../assets/images/no-data.png" alt="" class="no-data-img">
    <div class="name">暂无数据</div>
  </div>
</template>
<script>
export default {
  name: 'MyDialog',
  inheritAttrs: false,
  data() {
    return {

    }
  },
  computed: {
  },
  watch: {

  },
  mounted() {
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.no-data {
    padding-top: 60px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .no-data-img {
        width: 30px;
        height: 30px;
        margin-bottom: 12px;
    }
    .name {
        font-size: 11px;

        font-weight: 400;
        color: #999999;
        line-height: 15px;
    }
}
</style>
